import { render, staticRenderFns } from "./lrViewTable.vue?vue&type=template&id=5a1dbca8&"
import script from "./lrViewTable.vue?vue&type=script&lang=js&"
export * from "./lrViewTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports